import { render, staticRenderFns } from "./disposalPlan.vue?vue&type=template&id=bf229e06&scoped=true&"
import script from "./disposalPlan.vue?vue&type=script&lang=js&"
export * from "./disposalPlan.vue?vue&type=script&lang=js&"
import style0 from "./disposalPlan.vue?vue&type=style&index=0&id=bf229e06&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf229e06",
  null
  
)

export default component.exports